import {takeEvery, put, call, all, fork} from "redux-saga/effects"

import {
  ANALYTICAL_ACCOUNTS_LIST,
  ANALYTICAL_ACCOUNTS_NEW,
  ANALYTICAL_ACCOUNTS_EDIT,
  ANALYTICAL_ACCOUNTS_DELETE,
} from "./actionTypes"

import {
  analyticalAccountsListSuccess,
  analyticalAccountsListError,
  analyticalAccountsNewSuccess,
  analyticalAccountsNewError,
  analyticalAccountsDeleteSuccess,
  analyticalAccountsDeleteError,
} from "./actions"

import {
  apiGetAnalyticalAccountsList,
  apiPostAnalyticalAccountsNew,
  apiPatchAnalyticalAccountsEdit,
  apiDeleteAnalyticalAccountsDelete,
} from "../../../api/calls/analyticalAccounts"

function* analyticalAccountsList({payload: data}) {
  try {
    const response = yield call(apiGetAnalyticalAccountsList, data)
    yield put(analyticalAccountsListSuccess(response))
  } catch (error) {
    yield put(analyticalAccountsListError(error))
  }
}

function* analyticalAccountsNew({payload: data}) {
  try {
    const response = yield call(apiPostAnalyticalAccountsNew, data)
    yield put(analyticalAccountsNewSuccess(response))
  } catch (error) {
    yield put(analyticalAccountsNewError(error))
  }
}

function* analyticalAccountsEdit({payload: data}) {
  try {
    const response = yield call(apiPatchAnalyticalAccountsEdit, data)
    yield put(analyticalAccountsNewSuccess(response))
  } catch (error) {
    yield put(analyticalAccountsNewError(error))
  }
}

function* analyticalAccountsDelete({payload: data}) {
  try {
    const response = yield call(apiDeleteAnalyticalAccountsDelete, data)
    yield put(analyticalAccountsDeleteSuccess(response))
  } catch (error) {
    yield put(analyticalAccountsDeleteError(error))
  }
}

export function* watchAnalyticalAccountsList() {
  yield takeEvery(ANALYTICAL_ACCOUNTS_LIST, analyticalAccountsList);
}

export function* watchAnalyticalAccountsNew() {
  yield takeEvery(ANALYTICAL_ACCOUNTS_NEW, analyticalAccountsNew);
}

export function* watchAnalyticalAccountsEdit() {
  yield takeEvery(ANALYTICAL_ACCOUNTS_EDIT, analyticalAccountsEdit);
}

export function* watchAnalyticalAccountsDelete() {
  yield takeEvery(ANALYTICAL_ACCOUNTS_DELETE, analyticalAccountsDelete);
}

function* analyticalAccountsSaga() {
  yield all([
    fork(watchAnalyticalAccountsList),
    fork(watchAnalyticalAccountsNew),
    fork(watchAnalyticalAccountsEdit),
    fork(watchAnalyticalAccountsDelete),
  ]);
}

export default analyticalAccountsSaga
